import React, { useState, /*useContext*/ } from 'react'
// import StoreContext from '../../context/store/StoreContext'
// import ModalActionAndTrigger from '../ui/ModalActionAndTrigger'
import { PencilIcon, TrashIcon, PencilSquareIcon } from '../../img/images'
import TailwindModal from '../layout/TailwindModal'
import { withComponentLabel } from '../../utils/debug'

const StoreDetailHeader = (props) => {
  const { store, deleteClick /*backButton*/ } = props
  const [editMode, setEditMode] = useState(false)
  const [showDisplay, setShowDisplay] = useState(false)
  // const storeContext = useContext(StoreContext)

  const onEditClick = () => {
    console.log('edit click')
    setEditMode(!editMode)
  }

  const onDeleteClick = () => {
    console.log('delete click')
    setShowDisplay(!showDisplay)
  }

  return (
    <>
      cname StoreDetailHeader/
      <div className="flex ml-auto p-5">
        <div className="flex items-center justify-center">
          <div
            className={`${
              editMode ? 'block' : 'hidden'
            } bg-slate-300 rounded-full flex items-center justify-center`}
          >
            <button className="mx-4 py-2 px-4">
              <PencilSquareIcon color="fill-blue-400" />
            </button>
            <button
              onClick={onDeleteClick}
              className="mx-4 py-2 px-4"
            >
              <TrashIcon color="fill-blue-400" />
              <TailwindModal showDisplay={showDisplay}>
                <div className="flex flex-col gap-4 leading-snug p-5 bg-gray-50 border-t-2 border-gray-300 shadow-inner shadow-gray-200">
                  <div className="w-full h-full text-bold">
                    <span className="leading-relaxed tracking-wider font-bold">
                      Delete Store
                    </span>
                  </div>
                  <div className="tracking-tight leading-loose">
                    This cannot be undone!
                  </div>{' '}
                  <div className="tracking-tight leading-loose">Continue?</div>
                  <button
                    onClick={deleteClick}
                    className="bg-emerald-500 rounded-full text-white p-3"
                  >
                    OK
                  </button>
                </div>
              </TailwindModal>
            </button>
          </div>
          <button
            // className={`${editMode && ''} shadow-emerald-400 shadow-2xl`}
            onClick={onEditClick}
          >
            <PencilIcon
              width="12"
              height="12"
              color="fill-emerald-500"
              stroke={editMode && 'blue'}
            />
          </button>
        </div>
      </div>
      <div className="flex justify-center text-5xl items-center font-extrabold">
        {store.name}
      </div>
      {/* TODO remove below */}
      {/* <div className='row'>
        <div className='valign-wrapper detail-header center'>
          <div className='col s2 detail-header-icon'>{backButton}</div>
          <div className='col s8 center'>
            <span className='detail-header-text'>{store.name}</span>
          </div>
          <div className='col s2 detail-header-icon'>
            <ModalActionAndTrigger
              modalId='deleteConfirmModal'
              modalContent={deleteConfirm}
              action={deleteClick}
              trigger={deleteTrigger}
            />
          </div>
        </div>
      </div> */}
    </>
  )
}

export default withComponentLabel(StoreDetailHeader, 'StoreDetailHeader')
